module.exports = __webpack_public_path__ + "static/media/illustrator.80555b0a.svg";